import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';

export default function getFilterLastUpdate({ filterParams }: Values) {
  return (
    _get(filterParams, MonitoringFilterFieldNames.LastUpdate) ||
    new Date().toISOString()
  );
}
